import React from 'react';
function ArrowBackIos() {
    return (React.createElement("g", null,
        React.createElement("path", { d: "M11.67 3.87L9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z" }),
        React.createElement("path", { fill: "none", d: "M0 0h24v24H0z" })));
}
export default ArrowBackIos;
